import type { CSSProperties } from 'react';

export const STAR_PATH = 'M12 2.8l2.7 5.6 6.1.8-4.5 4.3 1.1 6.1L12 16.7l-5.4 2.9 1.1-6.1-4.5-4.3 6.1-.8z';
export const TP_STAR_PATH =
  'M17.227 16.67l2.19 6.742-7.413-5.388 5.223-1.354zM24 9.31h-9.165L12.005.589l-2.84 8.723L0 9.3l7.422 5.397-2.84 8.714 7.422-5.388 4.583-3.326L24 9.311z';

// The 4.9 rating's stars fill in one at a time, half a second apart. The last star is 90% gold: the star
// spans x 3.2 to 20.8 of its 24-wide box, so 90% of the star is 79% of the box.
const RATING_FILLS: ReadonlyArray<string> = ['100%', '100%', '100%', '100%', '79%'];

/** The 4.9 out of 5 session rating as five gold stars that pop in one by one (the hero's, and the chat's). */
export const RatingStars = () => (
  <span className="tm-stars" aria-hidden="true">
    {RATING_FILLS.map((fill, i) => (
      <i key={i} style={{ '--i': i, '--fill': fill } as CSSProperties}>
        <svg viewBox="0 0 24 24" className="tm-off">
          <path d={STAR_PATH} fill="#ffffff" stroke="#b9bed0" strokeWidth="1.4" strokeLinejoin="round" />
        </svg>
        <svg viewBox="0 0 24 24" className="tm-on">
          <path d={STAR_PATH} fill="#f2b84b" stroke="#2a3352" strokeWidth="1.4" strokeLinejoin="round" />
        </svg>
      </i>
    ))}
  </span>
);
